<template>
  <div class="documents col-md-12" v-if="transportFilesList.length > 0">
    <div>
      <div class="form-fieldhelp" style="right: 15px">
        <label>?</label>
        <div class="form-fieldhelp-text">
          <div>
            Прикрепите сканы документов в соответствующие для них разделы.
            <br/>Максимально допустимый размер файла - 2 МБ.
            <br/>Допустимые расширения файлов: jpg, jpeg, png, pdf, bmp, webp.
          </div>
        </div>
      </div>
      <div v-if="transport.docError" class="form-fielderror" style="right: 40px">
        <label>!</label>
        <div class="form-fielderror-text">
          <div>Загрузите документы</div>
        </div>
      </div>
      <h4>Документы</h4>
    </div>
    <div class="panel-group documents-form-flex" :id="`visitor-${visitorIndex}-transport-${transportIndex}`">
      <template v-for="(documentObj, documentKey) in transportFilesList">
        <div :id="`visitor${visitorIndex}-transport${transportIndex}-document-block-${documentObj.document.short_name}`" :key="documentKey">
          <uppy-uploader
              v-model="transport.files[documentObj.document.short_name]"
              :dashboard-show-condition="isNew || isDuplicate || isDraft || isEdit"
              :document-comment="documentObj.comment"
              :document-key="`visitor${visitorIndex}-transport${transportIndex}-${documentObj.document.short_name}`"
              :document-name="documentObj.document.name"
              :document-short-name="documentObj.document.short_name"
              :documents-show-condition="isView"
              :document-need-expire = "documentObj.need_expire"
              :max-files-count="documentObj.document.max_file"
              :document-id="documentObj.document.id"
               entity-type="transport"
              :entity-id="transport.id"
              :files-request="requestTransportFiles"
              :get-uuid="getUUID"
              :has-errors="blockHasErrors(documentObj.document.short_name)"
              :key="`transport${transport.uuid}-${documentObj.document.short_name}`"
              :form="form"
              ref="uploader"
              @file-removed="onFileRemoved($event, documentObj.document.short_name)"
          />
          <div class="error-text" v-html="blockErrors(documentObj.document.short_name)"/>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { ApiClient } from '@/common/helpers/api-client/ApiClient'
import UppyUploader from '../../../inputs/UppyUploader'
import hasErrorsMixin from '../../../../mixins/hasErrorsMixin'
import transportInputMixin from '../../../../mixins/application-form/transportInputMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import applicationInputMixin from '../../../../mixins/applicationInputMixin'

export default {
  name: 'TransportDocumentsFormBlock',

  components: {
    UppyUploader
  },

  mixins: [
    hasErrorsMixin,
    transportInputMixin,
    visitorInputMixin,
    applicationFormMixin,
    applicationInputMixin
  ],

  props: {
    form: {
      type: Object,
      default: () => ({})
    },

    transportDocuments: {
      type: [Object, Array],
      default: () => []
    }
  },

  data: () => ({
    baseUrl: process.env.VUE_APP_API_BASE_URL
  }),

  updated() {
    this.$refs?.uploader?.forEach((uppy) => {
      uppy.$forceUpdate()
    })
  },

  computed: {
    transportFilesErrors() {
      if (this.errors?.visitors && this.errors?.visitors[this.visitorIndex]?.transports[this.transportIndex]) {
        return this.errors?.visitors[this.visitorIndex]?.transports[this.transportIndex] ?? {}
      }

      return {}
    },

    transportFilesList() {
      return this.transportDocuments.filter(
        (document) => document.transport_id === this.transport.type || document.transport_id === null
      )
    }
  },

  methods: {
    blockHasErrors (field) {
      return this.hasError(this.errors?.visitors?.[this.visitorIndex]?.transports?.[this.transportIndex], field)
    },

    blockErrors (field) {
      return this.errors?.visitors?.[this.visitorIndex]?.transports?.[this.transportIndex][field]
    },

    async fileRemoved(uuid, ext) {
      await ApiClient.removeUploadedDocument({ uuid, ext })
    },

    getUUID(file) {
      return file.uuid
    },

    onFileRemoved(file, docName) {
      let ext = file.name.split('.').pop().toLowerCase()

      this.fileRemoved(file.meta.uuid, ext)
      this.removeTransportFile(this.transport, docName)
    },

    onUploadSuccess(file, docName) {
      let ext = file.name.split('.').pop().toLowerCase()

      if (!this.transport?.files) {
        this.transport.files = {}
      }

      if (!this.transport.files[docName]) {
        this.transport.files[docName] = []
      }

      this.transport.files[docName].push({
        uuid: file.meta.uuid + '.' + ext
      })
    },

    removeTransportFile(transport, docName) {
      if (transport.files[docName].length === 0) {
        delete transport.files[docName];
      }
    },

    async requestTransportFiles(docName) {
      let vue = this;

      await ApiClient.getTransportDocuments({
        transport_id: this.transport.id,
        doc_type: docName
      }).then(function (response) {
        const responseData = response.data.data
        if (vue.transport && !vue.transport.files) {
          vue.$set(vue.transport, 'files', [])
        }

        if (responseData[vue.transport.id]) {
          vue.$set(vue.transport.files, docName, responseData[vue.transport.id][docName])
        }
      })
    }
  }
}
</script>
